export default __webpack_public_path__ + "static/media/border-cap-square-17.4073cd22.svg";